<!-- If customer selected device and come from PDP page display device on top of PS page -->
<ng-container *ngIf="!isNewProductSelectorTemplateEnabled; else digitalProductSelectorView">
  <div>
    <ng-container *ngIf="focusedTileIdDetails?.selectedDevice; else DeviceNotSelected">
      <!-- <tmo-device-details *ngIf="aemContent"
    [deviceDetails]="focusedTileIdDetails?.deviceDetails"
    [selectedItem]="focusedTileIdDetails?.selectedDevice"
    [noNeedPlan] = "noNeedPlan"
    [selectedPlanPrice]="focusedTileIdDetails?.plansFromCart?.salesPrice" [isExistingLine]="isExistingLine"
    [isAssistedFlow]="isAssistedFlow" [pdpStaticContent]="aemContent" [isProductSelector]="true"
    [isUpgrade]="focusedTileIdDetails?.isUpgrade"> -->
      <tmo-device-details
        *ngIf="aemContent"
        [deviceDetails]="focusedTileIdDetails?.deviceDetails"
        [selectedItem]="focusedTileIdDetails?.selectedDevice"
        [noNeedPlan]="noNeedPlan"
        [selectedPlanPrice]="focusedTileIdDetails?.plansFromCart?.salesPrice"
        [isExistingLine]="isExistingLine"
        [pdpStaticContent]="aemContent"
        [isProductSelector]="true"
        [isUpgrade]="focusedTileIdDetails?.isUpgrade"
      >
        <div class="row m-t-xl" changeDeviceLink>
          <div class="col-4">
            <h3 class="inline-block w-50">{{ aemContent?.device }}</h3>
          </div>
          <div class="col-8 text-end m-t-sm p-t-xs" *ngIf="!(isExistingLine && !isUpgrade)">
            <a
              href="javascript:void(0);"
              class="inline-block lead text-end lead"
              [routerLink]="deviceSubType"
              [queryParams]="{
                allowEdit: true,
                isEditingUpgradeLine: focusedTileIdDetails?.isUpgrade,
                isEditingNonLineDevice: isUpgrade && !focusedTileIdDetails?.isUpgrade,
              }"
              id="cta-default-701"
            >
              {{ aemContent?.changeDevice }}
            </a>
          </div>
        </div>
        <!--CPO and prepaid related screen -->

        <div class="row tertiaty-buttons task d-none d-md-flex" displayCPO>
          <!-- <div class="col-6 button-box small" *ngIf="!isRetail"> -->
          <div class="col-6 button-box small">
            <a
              href="javascript:void(0);"
              (click)="navigateToDevicePdp()"
              attr.aria-label="{{ aemContent?.learnMore }}"
              id="cta-learn-more-6"
            >
              <span class="center">
                <i class="fa fa-info-circle"></i>
                <br />{{ aemContent?.learnMore }}</span
              >
            </a>
          </div>
          <!-- <div class="button-box small" *ngIf="!isCpoClicked ; else refurbished"
        [ngClass]="isRetail ? 'col-12' : 'col-6'"> -->
          <div class="button-box small col-6" *ngIf="!isCpoClicked; else refurbished">
            <a
              href="javascript:void(0);"
              [class.disabled]="!hasCPO"
              attr.aria-label="{{ aemContent?.certifiedPreOwned }}"
              (click)="goToPdp(true)"
              id="cta-certified-pre-owned-2"
            >
              <span class="center">
                <i class="tmo-icon-certified-preowned"></i>
                <br />{{ aemContent?.certifiedPreOwned }}</span
              >
            </a>
          </div>
          <ng-template #refurbished>
            <div class="col-6 button-box small">
              <a
                href="javascript:void(0);"
                attr.aria-label="{{ aemContent?.allModels }}"
                (click)="goToPdp(false)"
                id="cta-all-models-2"
              >
                <span class="center">
                  <i class="tmo-icon-certified-preowned"></i>
                  <br />{{ aemContent?.allModels }}</span
                >
              </a>
            </div>
          </ng-template>
        </div>
        <!--Emd of CPO and prepaid related screen -->
      </tmo-device-details>
      <div class="row m-t-xl" *ngIf="!isUpgrade">
        <div class="col-12">
          <hr class="divider" />
        </div>
      </div>
    </ng-container>
    <!-- End of If customer selected device and come from PDP page display device on top of PS page -->
    <!-- If customer selected BYOD flow -->
    <ng-template #DeviceNotSelected>
      <!-- If customer selects I Need a sim -->
      <tmo-byod-device-section
        [byodDeviceAemContent]="aemContent"
        [focusedTileIdDetails]="focusedTileIdDetails"
        [amount]="focusedTileIdDetails?.byodSimData?.salesPrice"
        *ngIf="focusedTileIdDetails?.byodCMMOrImei?.imei || focusedTileIdDetails?.byodSimData"
      ></tmo-byod-device-section>
      <!-- End of If customer selects I Need a sim -->
    </ng-template>
    <!-- End of If customer selected BYOD flow -->

    <!-- Display Plans if new customer -->

    <div class="row m-t-xl" *ngIf="!isUpgrade">
      <h3 class="col-6">{{ aemContent?.plans }}</h3>
      <p
        *ngIf="focusedTileIdDetails?.plansFromCart?.id && !isExistingLine"
        class="col-6 text-end lead"
      >
        <a
          attr.aria-label="{{ aemContent?.addALine }}"
          tabindex="-1"
          [routerLink]="['/browse-plans-phone']"
          [queryParams]="{ allowEdit: true }"
          id="cta-add-aline-4"
        >
          {{ aemContent?.changePlan }}</a
        >
      </p>
    </div>
    <!-- <ng-template #digitalPlansViewHeading>
    <div class="row m-t-xl">
      <h3 class="col-6">Prepaid plan</h3>
      <p *ngIf="focusedTileIdDetails?.plansFromCart?.id && !isExistingLine" class="col-6 text-end lead">
        <a attr.aria-label="{{aemContent?.addALine}}" tabindex="-1" [routerLink]="['/browse-plans-phone']"
          [queryParams]="{allowEdit: true}" id="cta-add-aline-4">Edit</a>
      </p>
    </div>
  </ng-template> -->
    <ng-container *ngIf="!focusedTileIdDetails?.isUpgrade">
      <tmo-selected-plan
        [aemContent]="aemContent"
        [isExistingLine]="isExistingLine"
        [focusedTileIdDetails]="focusedTileIdDetails"
        *ngIf="focusedTileIdDetails?.plansFromCart?.planOfferName"
      >
      </tmo-selected-plan>
    </ng-container>
    <div [hidden]="isExistingLine">
      <ng-container *ngIf="!isUpgrade">
        <tmo-plan-family
          [isProductSelector]="true"
          [aemContent]="aemContent"
          [isAddLine]="false"
          [disablePlanBlade]="
            (isMaxlinesReached || !hasRepPermissionToAddFirstLine) &&
            focusedTileIdDetails?.disableIDontNeedCheckbox
          "
          [noPlanNeeded]="noNeedPlan"
          [selectedPlanOfferId]="focusedTileIdDetails?.plansFromCart?.offerCode"
        >
        </tmo-plan-family>
        <tmo-no-plan-needed
          *ngIf="!isByos && !isByod"
          [aemContent]="aemContent"
          [noPlanNeeded]="focusedTileIdDetails?.noPlanNeeded"
          [disableCheckbox]="
            (isMaxlinesReached || !hasRepPermissionToAddFirstLine) &&
            focusedTileIdDetails?.lineTileType === 1
          "
          (isNoPlanSelected)="updateNoPlanSelected($event)"
          [isPlanAdded]="focusedTileIdDetails?.plansFromCart?.id"
          [focusedTileIdDetails]="focusedTileIdDetails"
        >
        </tmo-no-plan-needed>
      </ng-container>
      <!-- <ng-template #digitalPlansView>
      <tmo-plan-family-web [isProductSelector]="true" [aemContent]="aemContent" [isAddLine]="false"
        [disablePlanBlade]="(isMaxlinesReached || !hasRepPermissionToAddFirstLine) && focusedTileIdDetails?.disableIDontNeedCheckbox"
        [noPlanNeeded]="noNeedPlan" [selectedPlanOfferId]="focusedTileIdDetails?.plansFromCart?.offerCode">
      </tmo-plan-family-web>
    </ng-template> -->
      <ng-container *ngIf="isDeviceCarouselSectionEnabled">
        <h3 scId="SC1055" class="m-t-xl">{{ aemContent?.device }}</h3>
        <div
          class="m-t-lg"
          *ngIf="
            !focusedTileIdDetails?.plansFromCart?.id &&
            (focusedTileIdDetails?.noPlanNeeded || !isPlanOrNoPlanSelected) &&
            !focusedTileIdDetails?.disableIDontNeedCheckbox
          "
        >
          <p class="alert-text">
            <i class="fa fa-flag def alert-icon"></i> {{ aemContent?.choosePlanMessage }}
          </p>
           
          <div class="m-t-lg">
            <hr class="divider" />
          </div>
        </div>
      </ng-container>
      <tmo-device-section
        [deviceSectionAEMContent]="aemContent"
        [noPlanNeeded]="focusedTileIdDetails?.noPlanNeeded"
        [isByosFlow]="isByos"
        *ngIf="isPlanOrNoPlanSelected"
      ></tmo-device-section>
    </div>
    <div [hidden]="isUpgrade && !focusedTileIdDetails?.isUpgrade" *ngIf="aemContent">
      <tmo-service-section
        [softGoodsAEMContent]="aemContent"
        [disableServiceBlade]="
          focusedTileIdDetails?.noPlanNeeded || focusedTileIdDetails?.disableIDontNeedCheckbox
        "
        [isUpgrade]="focusedTileIdDetails?.isUpgrade"
        (serviceSuccess)="plansSectionCollapse($event)"
      ></tmo-service-section>
    </div>
    <tmo-line-summary *ngIf="aemContent" [aemContent]="aemContent"></tmo-line-summary>
    <tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
  </div>
</ng-container>

<ng-template #digitalProductSelectorView>
  <!-- Device Section -->
  <ng-container *ngIf="focusedTileIdDetails?.selectedDevice; else DeviceNotSelected">
    <tmo-device-selection-details
      *ngIf="aemContent && !isNewPlansPageEnabled"
      [deviceDetails]="focusedTileIdDetails?.deviceDetails"
      [selectedItem]="focusedTileIdDetails?.selectedDevice"
      [pdpStaticContent]="aemContent"
      [isUpgrade]="focusedTileIdDetails?.isUpgrade"
    >
      <div class="row m-t-xl" changeDeviceLink>
        <div class="col-9 col-md-5">
          <p class="device-heading inline-block">{{ aemContent?.device }}</p>
        </div>
        <div class="col-3 col-md-7 text-end" *ngIf="!(isExistingLine && !isUpgrade)">
          <a
            href="javascript:void(0);"
            class="inline-block lead text-end"
            [routerLink]="deviceSubType"
            [queryParams]="{
              allowEdit: true,
              isEditingUpgradeLine: focusedTileIdDetails?.isUpgrade,
              isEditingNonLineDevice: isUpgrade && !focusedTileIdDetails?.isUpgrade,
            }"
            id="cta-default-701"
          >
            {{ aemContent?.edit }}
          </a>
          <!-- <a href="javascript:void(0);" class="inline-block lead text-end" (click)="navigateToDevicePdp()"
              id="cta-default-701">
              {{aemContent?.edit}}
            </a> -->
        </div>
      </div>
    </tmo-device-selection-details>

    <div class="row m-t-xl" *ngIf="!isUpgrade && !isNewPlansPageEnabled">
      <div class="col-12">
        <hr class="divider" />
      </div>
    </div>
  </ng-container>
  <!-- End of If customer selected device and come from PDP page display device on top of PS page -->
  <!-- If customer selected BYOD flow -->
  <ng-template #DeviceNotSelected>
    <!-- If customer selects I Need a sim -->
    <tmo-byod-device-section
      [byodDeviceAemContent]="aemContent"
      [focusedTileIdDetails]="focusedTileIdDetails"
      [amount]="focusedTileIdDetails?.byodSimData?.salesPrice"
      *ngIf="
        (focusedTileIdDetails?.byodCMMOrImei?.imei || focusedTileIdDetails?.byodSimData) &&
        !isNewPlansPageEnabled
      "
    >
    </tmo-byod-device-section>

    <!-- End of If customer selects I Need a sim -->
  </ng-template>
  <!-- End of If customer selected BYOD flow -->
  <!-- Plans Section -->
  <div class="row m-t-xl" *ngIf="!isUpgrade">
    <div class="col-9 col-md-5">
      <h5 *ngIf="!isConnectBrand" class="inline-block">{{ aemContent?.prepaidPlan }}</h5>
    </div>
    <div
      *ngIf="focusedTileIdDetails?.plansFromCart?.id && !isExistingLine"
      class="col-3 col-md-7 text-end lead"
      [hidden]="!serviceSuccess"
    >
      <a
        attr.aria-label="{{ aemContent?.addALine }}"
        href="javascript:void(0);"
        tabindex="-1"
        class="inline-block"
        (click)="plansSectionCollapse(false)"
        id="cta-add-aline-4"
        >{{ aemContent?.edit }}</a
      >
    </div>
  </div>
  <ng-container *ngIf="!focusedTileIdDetails?.isUpgrade">
    <tmo-selected-plan
      [hidden]="!serviceSuccess"
      [aemContent]="aemContent"
      [isExistingLine]="isExistingLine"
      [digitalPlansView]="isNewProductSelectorTemplateEnabled"
      [focusedTileIdDetails]="focusedTileIdDetails"
      *ngIf="focusedTileIdDetails?.plansFromCart?.planOfferName"
    >
    </tmo-selected-plan>
  </ng-container>
  <ng-container *ngIf="!isUpgrade">
    <tmo-plan-family
      [hidden]="serviceSuccess"
      [isProductSelector]="true"
      [aemContent]="aemContent"
      [isAddLine]="false"
      [digitalPlansView]="isNewProductSelectorTemplateEnabled"
      [disablePlanBlade]="
        (isMaxlinesReached || !hasRepPermissionToAddFirstLine) &&
        focusedTileIdDetails?.disableIDontNeedCheckbox
      "
      [isSkipServiceNewFlow]="ishideServiceSection"
      [noPlanNeeded]="noNeedPlan"
      [selectedPlanOfferId]="focusedTileIdDetails?.plansFromCart?.offerCode"
      [familyCode]="focusedTileIdDetails?.plansFromCart?.familyCode"
      (isLimitedPlanSelected)="hideServiceSection($event)"
      (goToCart)="goToCart()"
      (selectedPlanFamily)="changeDisclaimer($event)"
      (showPlanSection)="showPlanSection($event)"
      [autopayDiscountDetailsModal]="autopayDiscountDetailsModal"
      [autoPayDiscountEnabled]="autoPayDiscountEnabled"
    >
    </tmo-plan-family>
    <tmo-purchase-device-only
      [hidden]="serviceSuccess"
      *ngIf="!isByos && !isByod && !isPlanFirst && !!isPlanSectionEnabled"
      [aemContent]="aemContent"
      (isNoPlanSelected)="updateNoPlanSelected($event)"
      [isNewPlansPageEnabled]="isNewPlansPageEnabled"
    ></tmo-purchase-device-only>
    <p
      *ngIf="
        !!isPlanSectionEnabled &&
        !(
          (isMaxlinesReached || !hasRepPermissionToAddFirstLine) &&
          focusedTileIdDetails?.disableIDontNeedCheckbox
        )
      "
      class="m-t-xl m-b-xl"
      [hidden]="serviceSuccess"
      id="disclaimer"
    >
      {{ disclaimer }}
    </p>
  </ng-container>

  <!-- Services Section -->
  <ng-container *ngIf="!ishideServiceSection">
    <div class="m-b-xl" [hidden]="isUpgrade && !focusedTileIdDetails?.isUpgrade" *ngIf="aemContent">
      <tmo-service-section
        [softGoodsAEMContent]="aemContent"
        [disableServiceBlade]="
          focusedTileIdDetails?.noPlanNeeded || focusedTileIdDetails?.disableIDontNeedCheckbox
        "
        [isUpgrade]="focusedTileIdDetails?.isUpgrade"
        (serviceSuccess)="plansSectionCollapse($event)"
      ></tmo-service-section>
    </div>
  </ng-container>
  <tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
</ng-template>
<tmo-dynamic-modal [modal]="autopayDiscountDetailsModal">
  <ng-container header>
    <div class="modal-logo-close">
      <a
        tabindex="0"
        [attr.aria-label]="aemContent?.clickToClose"
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="toggleAutopayDiscountDetailsModal(false)"
        id="cta-click-to-close-3_{{ autopayDiscountDetailsModal.modalName }}"
      >
        <i class="fa fa-times-circle"></i>
      </a>
    </div>
    <div class="row">
      <div class="col-12 m-t-md">
        <h3>{{ autopayDiscountDetailsModal?.headerText }}</h3>
      </div>
    </div>
  </ng-container>
  <div class="digital m-b-xl">
    <p
      class="small"
      id="pdialog-bodytext"
      [innerHtml]="autopayDiscountDetailsModal?.bodyText"
    ></p>
  </div>
</tmo-dynamic-modal>